import * as React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { Switch, Route, useParams, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import {
    Grid,
    Paper,
    Typography,
    AppBar, Tabs, Tab,
    FormControl, InputLabel, Select, MenuItem, TextField,
    Divider,
    Button, Switch as SwitchComp,
    FormGroup, FormControlLabel
} from '@material-ui/core';

import { useSnackbar } from 'notistack';

import * as Wellspring from '@greenheck/wellspring';

import { LayoutEntity, LayoutEntityProps } from '../layoutEntity';

import { useServiceClient, usePreferences } from '../contexts';
import { CatalogEntry } from '../../lib/serviceClient';

import * as ConfigurationModelEntity from '../../lib/services/configuration.modelEntity';
import * as ConfigurationModelLayout from '../../lib/services/configuration.modelLayout';
import * as ConfigurationModelDictionary from '../../lib/services/configuration.modelDictionary';
import * as ConfigurationCore from '../../lib/services/configuration.core';
import * as ConfigurationProjectionLayout from '../../lib/services/configuration.projectionLayout';

const styles = makeStyles((theme) => ({
    root: {
        // background: '#c6cacf'
    },
    formControl: {
        minWidth: 150,
        paddingBottom: theme.spacing(1)
    },
    paperContainer: {
        padding: theme.spacing(1)
    },
    entityContainer: {
        padding: theme.spacing(1),
        background: '#F2F3F4'
    },
    textarea: {
        // resize: 'vertical',
        fontSize: 8,
        overflow: 'auto',
        maxWidth: '100%',
        maxHeight: 400
        // whiteSpace: 'nowrap'
    },
}));

export function Configuration() {
    const classes = styles();

    const { enqueueSnackbar } = useSnackbar();

    const location = useLocation();
    const history = useHistory();

    const urlParams = new URLSearchParams(location.search);
    const entityKey = urlParams.get('entityKey');
    const layoutKey = urlParams.get('layoutKey');

    const serviceClient = useServiceClient();
    const [ preferences, setPreferences ] = usePreferences();

    const [ debugging, setDebugging ] = React.useState<boolean>();

    React.useEffect(() => {
        if (!entityKey && !!preferences.configurationEntityId &&
            !layoutKey && !!preferences.configurationLayoutId) {
            history.replace(`/configuration?entityKey=${preferences.configurationEntityId}&layoutKey=${preferences.configurationLayoutId}`);
        }
        else if (!entityKey && !!preferences.configurationEntityId) {
            history.replace(`/configuration?entityKey=${preferences.configurationEntityId}`);
        }
    }, [ entityKey, layoutKey, preferences ]);

    const [ availableEntities, setAvailableEntities ] = React.useState<CatalogEntry[]>([]);
    React.useEffect(() => {(async () => {
        const entities = await serviceClient.getCatalogEntities();

        setAvailableEntities(entities);
    })().catch(err => {
        enqueueSnackbar('[Loading Catalog Entities] ' + err.toString(), { variant: 'error' });
        console.error(err)
        setAvailableEntities([]);
    })}, [ serviceClient ]);

    const [ selectedEntity, setSelectedEntity ] = React.useState<CatalogEntry>();
    React.useEffect(() => {(async () => {
        setSelectedEntity(availableEntities.find(i => i.key === entityKey));
    })()}, [ availableEntities, entityKey ]);
    const onSelectedEntityKeyChange = (e: React.ChangeEvent<{ value: string }>) => {
        setPreferences(prev => ({
            ...prev,
            configurationEntityId: e.target.value
        }));

        history.push(`/configuration?entityKey=${e.target.value}`);
    }

    const [ availableLayouts, setAvailableLayouts ] = React.useState<CatalogEntry[]>([]);
    React.useEffect(() => {(async () => {
        const layouts = await serviceClient.getCatalogLayouts();

        setAvailableLayouts(layouts);
    })().catch(err => {
        enqueueSnackbar('[Loading Catalog Layouts] ' + err.toString(), { variant: 'error' });
        console.error(err)
        setAvailableLayouts([]);
    })}, [ serviceClient ]);

    const [ selectedLayout, setSelectedLayout ] = React.useState<CatalogEntry>();
    React.useEffect(() => {(async () => {
        setSelectedLayout(availableLayouts.find(i => i.key === layoutKey));
    })()}, [ availableLayouts, layoutKey ]);
    const onSelectedLayoutKeyChange = (e: React.ChangeEvent<{ value: string }>) => {
        setPreferences(prev => ({
            ...prev,
            configurationLayoutId: e.target.value
        }));

        if (e.target.value)
            history.push(`/configuration?entityKey=${entityKey}&layoutKey=${e.target.value}`);
        else
            history.push(`/configuration?entityKey=${entityKey}`);
    }

    // const [ displayDictionary, setDisplayDictionary ] = React.useState<ConfigurationModelDictionary.DisplayDictionary>();
    // React.useEffect(() => {(async () => {
    //     const displayDictionary = await serviceClient.getDisplayDictionary('Framework/DisplayDictionary')

    //     setDisplayDictionary(displayDictionary);
    // })().catch(err => {
    //     enqueueSnackbar('[Loading Display Dictionary] ' + err.toString(), { variant: 'error' });
    //     console.error(err)
    // })}, [ serviceClient ]);

    const [ entityModel, setEntityModel ] = React.useState<ConfigurationModelEntity.Entity>();
    React.useEffect(() => {(async () => {
        // if (!selectedEntity)
        //     return;

        const entityModel = selectedEntity && await serviceClient.getEntity(selectedEntity.name);

        setEntityModel(entityModel);
    })().catch(err => {
        enqueueSnackbar('[Load Entity Model] ' + err.toString(), { variant: 'error' });
        console.error(err)
    })}, [ selectedEntity ]);

    const [ layoutModel, setLayoutModel ] = React.useState<ConfigurationModelLayout.Layout>();
    React.useEffect(() => {(async () => {
        // if (!selectedLayout)
        //     return;

        const layoutModel = selectedLayout && await serviceClient.getLayout(selectedLayout.name);

        setLayoutModel(layoutModel);
    })().catch(err => {
        enqueueSnackbar('[Load Layout Model] ' + err.toString(), { variant: 'error' });
        console.error(err)
    })}, [ selectedLayout ]);

    const [ coreEntity, setCoreEntity ] = React.useState<ConfigurationCore.Entity>();
    React.useEffect(() => {(async () => {
        // if (!entityModel)
        //     return;

        console.log('RECREATING CORE ENTITY')
        // if (entityModel?.businessUnit === 'LV' && entityModel.name === 'LouverConfigurationSelector_Schema') {
        //     const coreEntity = entityModel && await serviceClient.createCoreEntity(entityModel, [
        //         'Model=ESD-403',
        //         'FrameMaterialType=Galvanized',
        //         'FrameThickness=18'
        //     ]);
        //     setCoreEntity(coreEntity);
        // }
        // else {
            const coreEntity = entityModel && await serviceClient.createCoreEntity(entityModel);
            setCoreEntity(coreEntity);
        // }
    })().catch(err => {
        enqueueSnackbar('[Creating Core Entity] ' + err.toString(), { variant: 'error' });
        console.error(err)
    })}, [ entityModel ]);

    const [ layoutEntity, setLayoutEntity ] = React.useState<ConfigurationProjectionLayout.Entity>();
    React.useEffect(() => {(async () => {
        // if (!coreEntity || !layoutModel)
        //     return;

        const layoutEntity = coreEntity && await serviceClient.createLayoutEntity(coreEntity, layoutModel);
        console.log('Layout', layoutEntity);

        setLayoutEntity(layoutEntity);
        layoutEntity && enqueueSnackbar('Layout Refreshed', { variant: 'info' });

        const integrationEntity = coreEntity && await serviceClient.createIntegrationProjection(coreEntity);
        console.log('INTEGRATION ENTITY', integrationEntity);
    })().catch(err => {
        enqueueSnackbar('[Creating Layout] ' + err.toString(), { variant: 'error' });
        console.error(err)
    })}, [ coreEntity, layoutModel ]);

    React.useEffect(() => {
        if (!layoutEntity)
            return;

        if (layoutEntity.conflict && layoutEntity.conflict.messages.length > 0) {
            let conflictMessage = '--CONFLICT--';

            conflictMessage += '\n\nWARNINGS';
            for (const message of layoutEntity.conflict.messages.filter(m => m.type === ConfigurationProjectionLayout.ValidationMessageStates.SoftInvalid))
                conflictMessage += '\n' + message.message;
            conflictMessage += '\n\nERRORS';
            for (const message of layoutEntity.conflict.messages.filter(m => m.type === ConfigurationProjectionLayout.ValidationMessageStates.HardInvalid))
                conflictMessage += '\n' + message.message;

            console.log(conflictMessage);
        }
        else {
            console.log('--NO CONFLICT--')
        }
    }, [ layoutEntity ]);

    const [ lastUpdateResult, setLastUpdateResult ] = React.useState<ConfigurationCore.UpdateResult>();
    const onEntityChange: LayoutEntityProps['onChange'] = (e) => {
        if (!coreEntity)
            return;

        (async () => {
            await serviceClient.snapshotEntityState(coreEntity);
            const updateResults = await serviceClient.updateEntity(coreEntity, e.state);
            // setCoreEntity(undefined); setCoreEntity(coreEntity);
            setCoreEntity(new ConfigurationCore.Entity(coreEntity));
            setLastUpdateResult(updateResults);

            // const tmp = layoutEntity && await serviceClient.createLayoutScenario(layoutEntity, updateResults.conflict);
            // console.log('CONFLICT ADVISOR', tmp);
        })().catch(err => {
            enqueueSnackbar('[Updating Core Entity] ' + err.toString(), { variant: 'error' });
            console.error(err)
        });
    }

    const onTestClick = () => {
        if (!coreEntity)
            return;

        (async () => {
            const updateResults = await serviceClient.updateEntity(coreEntity, {
                'Model': '!AFA-801'
            });

            setCoreEntity(new ConfigurationCore.Entity(coreEntity));
            setLastUpdateResult(updateResults);
        })().catch(err => {
            enqueueSnackbar('[Updating Core Entity] ' + err.toString(), { variant: 'error' });
            console.error(err)
        });
    }

    const onSnapshotClick = () => {
        if (!coreEntity)
            return;

        (async () => {
            await serviceClient.snapshotEntityState(coreEntity);
            setCoreEntity(new ConfigurationCore.Entity(coreEntity));
        })().catch(err => {
            enqueueSnackbar('[Core Entity Snapshot] ' + err.toString(), { variant: 'error' });
            console.error(err)
        });
    }
    const onUndoClick = () => {
        if (!coreEntity)
            return;

        (async () => {
            // if (coreEntity.stateIndex === 0)
            //     await serviceClient.snapshotEntityState(coreEntity);

            await serviceClient.restoreEntityState(coreEntity, -1);
            setCoreEntity(new ConfigurationCore.Entity(coreEntity));
        })().catch(err => {
            enqueueSnackbar('[Core Entity Undo] ' + err.toString(), { variant: 'error' });
            console.error(err)
        });
    }
    const onRedoClick = () => {
        if (!coreEntity)
            return;

        (async () => {
            await serviceClient.restoreEntityState(coreEntity, 1);
            setCoreEntity(new ConfigurationCore.Entity(coreEntity));
        })().catch(err => {
            enqueueSnackbar('[Core Entity Redo] ' + err.toString(), { variant: 'error' });
            console.error(err)
        });
    }

    const onSaveStateClick = () => {
        if (!coreEntity)
            return;
    }

    // React.useEffect(() => {(async () => {
    //     if (!layoutEntity || !lastUpdateResult)
    //         return;

    //     const tmp = await serviceClient.createLayoutScenario(layoutEntity, lastUpdateResult.conflict);
    //     console.log('CONFLICT ADVISOR', tmp);
    // })().catch(err => {
    //     enqueueSnackbar('[Creating Layout] ' + err.toString(), { variant: 'error' });
    //     console.error(err)
    // })}, [ layoutEntity, lastUpdateResult ]);

    return (
        <Grid container xs={12} spacing={1} alignItems="flex-start">
            <Grid item container xs={3} spacing={1} direction="column" justify="flex-start">
                <Grid item xs>
                    <FormControlLabel label="Enable Debugging" control={<SwitchComp value={debugging} onChange={() => setDebugging(!debugging)} />} />
                </Grid>

                <Grid item xs>
                    <Paper className={classes.paperContainer}>
                        <Typography variant="h5">Parameters</Typography>

                        <Grid container spacing={1} direction="column">
                            <Grid item xs>
                                <FormControl fullWidth>
                                    <InputLabel id="entity-name-label">Entity</InputLabel>
                                    <Select labelId="entity-name-label" id="entity-name-select" value={selectedEntity?.key || ''} onChange={onSelectedEntityKeyChange}>
                                        {availableEntities.map(entity => <MenuItem value={entity.key}>{entity.displayName}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs>
                                <FormControl fullWidth>
                                    <InputLabel id="layout-name-label">Layout</InputLabel>
                                    <Select labelId="layout-name-label" id="layout-name-select" value={selectedLayout?.key || ''} onChange={onSelectedLayoutKeyChange}>
                                        <MenuItem value=""><em>None</em></MenuItem>
                                        {availableLayouts.map(layout => <MenuItem value={layout.key}>{layout.displayName}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>

                <Grid item xs>
                    <Button onClick={onTestClick}>Test</Button>
                    <Button onClick={onSnapshotClick}>Snapshot</Button>
                    <Button onClick={onUndoClick}>Undo</Button>
                    <Button onClick={onRedoClick}>Redo</Button>
                    <Button onClick={onSaveStateClick}>Save State</Button>
                </Grid>

                {/* <Grid item xs>
                    {lastUpdateResult && <Paper className={classes.paperContainer}>
                        <Typography variant="h5">Debug</Typography>

                        <pre className={classes.textarea}>
                            <code>
                                <p>{lastUpdateResult.debug.sortedKeys.join('\n')}</p>
                            </code>
                        </pre>
                    </Paper>}
                </Grid> */}
            </Grid>

            {/* <Divider variant="fullWidth" /> */}

            <Grid item container xs={9}>
                {layoutEntity && <LayoutEntity entity={layoutEntity} onChange={onEntityChange} debugging={debugging} />}
            </Grid>
        </Grid>
    );
}